<template>
  <div class="help">
    <div v-if="list.length > 0" class="list">
      <div v-for="(v,k) in list" v-bind:key="k"  @click="showw(v,k)" class="item topline bottomline">
        <div class="tit">{{v.title}}</div>
        <div v-if="v.show" class="txt topline">
            {{v.content}}
        </div>
      </div>
    </div>
    <div v-else class="nodata">暂无数据</div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      list:[]
    }
  },
  mounted(){
    this.getHelp()
  },
  methods:{
    showw(v,k){
      v.show = !v.show;
      this.$set(this.list, k,v);
    },
    getHelp(flag){
      let vm = this;
      vm.ajax("helper", "get", '', e => {
        vm.list =  e.data;
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/help.vue